import React, { useEffect, useState, Children } from 'react';
import { Button, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { toast } from 'react-toastify';
import textUtils from '../common/utilities/TextUtils';
import { ADD_UPDATE, DYNAMIC_TABLE, DYNAMIC_TABLE_ATTRIBUTE, DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET, LIST, getApiPath } from "../../api/ApiConst"
import apiCaller from "../../api/ApiCaller";
import { useCallback } from 'react';
import { get, set } from 'lodash';
import { getDataTypes, DataTypeConfigView } from '../../utils/datatypes/DataTypeConfig';

// Move to settings/constants
const ENUM_TYPE = 'ENUM'

// Helper function to validate attribute name
const isValidAttributeName = (name) => {
    return name && name.trim().length > 0;
};



const TableAttributeAddEdit = (props) => {
    const [attributeTypeKeyValue, setAttributeTypeKeyValue] = useState("");
    const [dataTypeOptions, setDataTypeOptions] = useState([]);
    const [isLoadingDataTypes, setIsLoadingDataTypes] = useState(false);
    const [configData, setConfigData] = useState({});
    const [attributeObj, setAttributeObj] = useState({
        id: "",
        tableId: "",
        name: "",
        label: "",
        type: "",
        defaultValue: {},
        config: {},
        nullValue: true,
        tableViewAttribute: true,
        comment: "",
        formAttribute: true,
        defaultAttribute: false,
        unique: false,
        listAttribute: false
    })

    const [referenceTableOptions, setReferenceTableOptions] = useState([])
    const [keyValueAttributeOptions, setKeyValueAttributeOptions] = useState([])
    const [mappingTableAttributeKeyValueOptions, setMappingTableAttributeKeyValueOptions] = useState([])
    const [dynamicKeyValueAttributeOptions, setDynamicKeyValueAttributeOptions] = useState([])
    const [hasDynamicOptions, setHasDynamicOptions] = useState(false)

    // Load data types on component mount
    useEffect(() => {
        loadDataTypes();
    }, []);
    
    const loadDataTypes = async () => {
        setIsLoadingDataTypes(true);
        try {
            const options = await getDataTypes();
            setDataTypeOptions(options);

            // If API returns empty array, fallback to TYPES_OPTIONS
            if (!options || options.length === 0) {
                console.log('API returned empty options, using TYPES_OPTIONS fallback');
            }
        } catch (error) {
            console.error('Error loading data types:', error);
        } finally {
            setIsLoadingDataTypes(false);
        }
    };

    // Handle configuration field changes for data type config
    const handleDataTypeConfigChange = (fieldName, value, fieldType = 'text') => {
        setConfigData(prev => ({
            ...prev,
            [fieldName]: value
        }));
    };

    // // Debug useEffect to monitor configData changes
    // useEffect(() => {
    //     console.log('configData changed:', configData);
    // }, [configData]);

    useEffect(() => {
        let url = getApiPath(DYNAMIC_TABLE, LIST);
        let requestObj = {
            page: 0,
            size: 1000,
            searchFilters: [],
            sortRules: []
        };
        let options = [];
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            response.data.map((tableData, i) => {
                options.push({ label: tableData.name, value: tableData._id })
            })
            setReferenceTableOptions(options);
            if (props.object.referenceTable !== null) {
                let obj = options.find(o => o.value === props.object.referenceTable);
                getKeyValueAttributeOptionsList(props.object.referenceTable)
            }
        }, (error) => {
            // toast.error(error.response.data.message);
            // toast.error(error);
        }
        )

    }, [])

    useEffect(() => {
        if (props.object != null) {
            console.log('Edit mode - props.object:', props.object);
            
            // Load all attributes for editing - preserve everything for edit mode
            const loadAttributesForEdit = (attrs) => {
                if (!Array.isArray(attrs)) return attrs || [];

                return attrs.map(attr => {
                    if (!attr) return attr;

                    const loadedAttr = { ...attr };

                    // Recursively load nested attributes for editing
                    // Check both config.attributes and direct attributes for backward compatibility
                    const nestedAttributes = attr.config?.attributes || attr.attributes;
                    if (nestedAttributes && Array.isArray(nestedAttributes)) {
                        loadedAttr.attributes = loadAttributesForEdit(nestedAttributes);
                    } else {
                        // Ensure attributes array exists for editing
                        loadedAttr.attributes = [];
                    }

                    return loadedAttr;
                });
            };

            // Load all attributes for editing - don't filter them out
            // Check both config.attributes and direct attributes for backward compatibility
            let loadedAttributes = [];
            const sourceAttributes = props.object.config?.attributes || props.object.attributes;
            if (sourceAttributes && Array.isArray(sourceAttributes)) {
                loadedAttributes = loadAttributesForEdit(sourceAttributes);
            }

            setAttributeObj({
                ...props.object,
                config: {
                    ...props.object.config,
                    attributes: loadedAttributes
                }
            });
            if (props.object.type !== "") {
                let selectedAttributeType = dataTypeOptions?.find(option => option?.value === props?.object?.type);

                setAttributeTypeKeyValue({
                    label: selectedAttributeType?.label || props.object.type,
                    value: selectedAttributeType?.value || props.object.type
                });
            } else {
                setAttributeTypeKeyValue("");
            }

            if (get(props, 'object.type') === ENUM_TYPE && get(props, 'object.enumValues')) {
                setAttributeObj(prev => ({ ...prev, enumValues: get(props, 'object.enumValues').split(',') }))
            }

            // Initialize configData for edit mode
            if (props.object && props.object.config) {
                console.log('Setting configData from props.object.config:', props.object.config);
                const configFromObject = props.object.config;
                setConfigData(configFromObject);
                
                // If this is a COLLECTION_OBJECT type, load the reference table attributes
                if (props.object.type === 'COLLECTION_OBJECT' && configFromObject.referenceTable) {
                    console.log('Loading reference table attributes for:', configFromObject.referenceTable);
                    getKeyValueAttributeOptionsList(configFromObject.referenceTable);
                }
            } else {
                console.log('No config found in props.object:', props.object);
            }
        }
    }, [props.object, dataTypeOptions]);

    // Close Attribute Create/Update Model Box
    const toggle = () => {
        props.close();
    }

    
    // get Key-Value attribute Options List 
    const getKeyValueAttributeOptionsList = useCallback(
        (tableId) => {
            console.log('getKeyValueAttributeOptionsList called with tableId:', tableId);
            
            if (!tableId) {
                console.warn('getKeyValueAttributeOptionsList: tableId is undefined or null');
                return;
            }
            
            let keyValueAttributeListUrl = DYNAMIC_TABLE_ATTRIBUTE_LIST_BY_TABLE_ID_GET.replaceAll("{dynamic-table-id}", tableId);
            console.log('API URL:', keyValueAttributeListUrl);
            
            var options = [];
            apiCaller.callPostApi(keyValueAttributeListUrl, tableId, {}, (response) => {
                console.log('API response for table attributes:', response);
                response.data.map((data, i) => {
                    options.push({ label: data.name, value: data.id })
                })
                
                // Set both keyValueAttributeOptions and dynamicKeyValueAttributeOptions
                setKeyValueAttributeOptions(options);
                if (setDynamicKeyValueAttributeOptions) {
                    setDynamicKeyValueAttributeOptions(options);
                }
                if (setHasDynamicOptions) {
                    setHasDynamicOptions(true);
                }
                console.log('Setting dynamicKeyValueAttributeOptions with length:', options.length);
            }, (error) => {
                console.error('Error loading key-value attribute options:', error);
                setKeyValueAttributeOptions(options);
                if (setDynamicKeyValueAttributeOptions) {
                    setDynamicKeyValueAttributeOptions([]);
                }
                if (setHasDynamicOptions) {
                    setHasDynamicOptions(false);
                }
            })
        },
        [props.object.referenceTable, setDynamicKeyValueAttributeOptions, setHasDynamicOptions],
    );

    //Text Change Event
    const handleTextChange = (e, type, id = "") => {
        if (type === "checkbox") {
            if (e.target.id === "nullValue") {
                setAttributeObj(prev => ({
                    ...prev,
                    [e.target.id]: e.target.checked,
                    defaultValue: {}
                }));
            } else {
                setAttributeObj(prev => ({ ...prev, [e.target.id]: e.target.checked }));
            }
        } else if (type === ENUM_TYPE) {
            setAttributeObj(prev => ({
                ...prev,
                enumValues: attributeObj.enumValues.map((state, stateIndex) =>
                    stateIndex === id ? e.target.value : state
                )
            })
            )
        } else if (type === "text") {
            setAttributeObj(prev => ({ ...prev, [e.target.id]: e.target.value }));
        } else if (type === "select") {
            if (id === "type") {
                setAttributeTypeKeyValue(e);
                // When type changes during editing, preserve existing attributes for editing
                const newType = e.value;
                let updatedAttributes = attributeObj.config?.attributes || [];

                // Keep existing attributes for editing, even if type changes
                // The cleaning will happen only when sending the payload

                setAttributeObj(prev => ({
                    ...prev,
                    [id]: newType,
                    config: {
                        ...prev.config,
                        attributes: updatedAttributes
                    }
                }));

                // Clear configData when type changes to prevent showing old fields
                setConfigData({});
            }
        }
    }

    const handleKeyPressOnlyAlphanumericUnderscore = (e) => {
        const key = e.key;
        if (
            key === 'Backspace' ||
            key === 'Delete' ||
            key === 'ArrowLeft' ||
            key === 'ArrowRight' ||
            key === 'Tab' ||
            key === 'Home' ||
            key === 'End'
        ) {
            return;
        }
        const isValid = /^[a-zA-Z0-9_]$/.test(key);
        if (!isValid) {
            e.preventDefault();
        }
    };


    // Create Attribute  
    const handleCreateAttribute = () => {
        let requestObj = attributeObj;
        if ((textUtils.isEmpty(requestObj.name, "Name", true)) ||
            textUtils.isEmpty(requestObj.type, "Type", true)) {
            return false;
        }
        console.log('Initial attributeObj : ', attributeObj);
        attributeObj.config = configData;
        console.log('configData : ', configData);
        
        // Validate attributes if type is OBJECT
        const objectAttributes = attributeObj.config?.attributes;
        if (attributeObj.type === "OBJECT" &&
            (!objectAttributes || objectAttributes.length === 0)) {
            toast.error("Please add at least one attribute for the object type");
            return false;
        }

        // Validate all attribute names and nested objects

        const validateAttributes = (attrs) => {
            if (!Array.isArray(attrs)) return true;

            return attrs.every(attr => {
                if (!attr) return true;

                // Check if attribute name is valid
                if (!isValidAttributeName(attr.name)) {
                    toast.error(`Attribute "${attr.name || 'Unnamed'}" must have a valid name`);
                    return false;
                }
                console.log("attr", attr);
                // Check if nested objects have at least one inner attribute
                if ((attr.type === "OBJECT")) {
                    // Check if nested attributes exist in config.attributes
                    const nestedAttributes = attr.config?.attributes || attr.attributes;
                    if (!nestedAttributes || nestedAttributes.length === 0) {
                        toast.error(`Nested object "${attr.name}" must have at least one inner attribute`);
                        return false;
                    }
                    // Recursively validate nested attributes
                    return validateAttributes(nestedAttributes);
                }

                return true;
            });
        };

        // Always validate attributes if they exist, regardless of the main type
        const attributesToValidate = attributeObj.config?.attributes;
        if (attributesToValidate && attributesToValidate.length > 0) {
            if (!validateAttributes(attributesToValidate)) {
                return false;
            }
        }
        if (requestObj.type === ENUM_TYPE) {
            const value = Array.isArray(requestObj.enumValues) ? requestObj.enumValues.filter(Boolean).join(',') : null
            set(requestObj, 'enumValues', value)
        } else {
            set(requestObj, 'enumValues', null)
        }

        // Initialize config object
        if (!requestObj.config) {
            requestObj.config = {};
        }

        // Save DataTypeConfig data into config field
        if (Object.keys(configData).length > 0) {
            requestObj.config = {
                ...requestObj.config,
                ...configData
            };
        }

        // Clean attributes recursively - ensure nested objects are stored in config, not directly in attributes
        const cleanAttributesRecursively = (attrs) => {
            if (!Array.isArray(attrs)) return attrs;

            return attrs.map(attr => {
                if (!attr) return attr;

                const cleanedAttr = { ...attr };

                // For OBJECT type attributes, ensure they have proper config structure
                if (attr.type === "OBJECT") {
                    // If the attribute has nested attributes, store them in config.attributes
                    if (attr.attributes && Array.isArray(attr.attributes)) {
                        if (!cleanedAttr.config) {
                            cleanedAttr.config = {};
                        }
                        cleanedAttr.config.attributes = cleanAttributesRecursively(attr.attributes);
                        // Remove the direct attributes field to prevent duplication
                        delete cleanedAttr.attributes;
                    }
                } else if (attr.type === "ARRAYOFOBJ") {
                    // For ARRAYOFOBJ, keep attributes in the main attributes field
                    if (attr.attributes && Array.isArray(attr.attributes)) {
                        cleanedAttr.attributes = cleanAttributesRecursively(attr.attributes);
                    }
                } else {
                    // Remove attributes key for non-object types
                    delete cleanedAttr.attributes;
                }

                return cleanedAttr;
            });
        };

        // For OBJECT type, copy attributes from configData to requestObj.config.attributes
        if (requestObj.type === "OBJECT" && configData.attributes) {
            // Store attributes in config.attributes, not directly in requestObj.attributes
            if (!requestObj.config) {
                requestObj.config = {};
            }
            requestObj.config.attributes = cleanAttributesRecursively(configData.attributes);
            console.log('Copied attributes from configData to requestObj.config.attributes:', requestObj.config.attributes);
        }

        // Remove the direct attributes field from requestObj for OBJECT type to prevent duplication
        if (requestObj.type === "OBJECT" && requestObj.attributes) {
            delete requestObj.attributes;
        }

        // Clean the requestObj attributes - for ARRAYOFOBJ type, attributes go in main object
        if (requestObj.attributes && Array.isArray(requestObj.attributes)) {
            if (requestObj.type === "ARRAYOFOBJ") {
                requestObj.attributes = cleanAttributesRecursively(requestObj.attributes);
            } else if (requestObj.type !== "OBJECT") {
                // Remove attributes key for other non-object types
                delete requestObj.attributes;
            }
        }

        // Clean config-related fields from main object to prevent duplication

        
        //return false;

        let url = getApiPath(DYNAMIC_TABLE_ATTRIBUTE, ADD_UPDATE);
        apiCaller.callPostApi(url, requestObj, {}, (response) => {
            toast.success(`Attribute ${attributeObj.id ? "Updated" : "Created"} Successfully`);
            props.successCallBack();
            toggle();
        }, (error) => {
            toast.error(error.response.data.message);
        })
    }



    return (
        <>
            <Modal show={props.show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>{props.object != null ? "Edit" : "Add"} Table Attribute</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Name *</label>
                            <input type="text" className="form-control input-default"
                                id="name"
                                placeholder='Name'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                onKeyDown={handleKeyPressOnlyAlphanumericUnderscore}
                                value={attributeObj.name}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Label *</label>
                            <input type="text" className="form-control input-default"
                                id="label"
                                placeholder='Label'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={attributeObj.label}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Type *</label>
                            <Select
                                options={dataTypeOptions}
                                value={attributeTypeKeyValue}
                                id="type"
                                onChange={(e) => handleTextChange(e, "select", "type")}
                                className="react-select-container"
                                isLoading={isLoadingDataTypes}
                                placeholder={isLoadingDataTypes ? "Loading data types..." : "Select Data Type"}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <input
                                type="checkbox"
                                name="listAttribute"
                                id="listAttribute"
                                checked={attributeObj.listAttribute || false}
                                onChange={(e) => handleTextChange(e, "checkbox")}
                            />
                            <label className='ms-2'>List Attribute</label>
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Default Value *</label>
                            <input type="text" className="form-control input-default"
                                id="defaultValue"
                                placeholder='Default Value'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={((typeof attributeObj.defaultValue) === "object") ? ((Object.keys(attributeObj.defaultValue).length) === 0) ? "" : attributeObj.defaultValue?.value : attributeObj.defaultValue}
                                disabled={attributeObj.nullValue}
                            />
                        </div>
                    </div>

                    <DataTypeConfigView
                        key={`datatype-config-${attributeTypeKeyValue?.value}`}
                        selectedDataType={attributeTypeKeyValue}
                        configData={configData}
                        onConfigChange={handleDataTypeConfigChange}
                        referenceTableOptions={referenceTableOptions}
                        keyValueAttributeOptions={keyValueAttributeOptions}
                        mappingTableAttributeKeyValueOptions={mappingTableAttributeKeyValueOptions}
                        dynamicKeyValueAttributeOptions={dynamicKeyValueAttributeOptions}
                        setDynamicKeyValueAttributeOptions={setDynamicKeyValueAttributeOptions}
                        hasDynamicOptions={hasDynamicOptions}
                        setHasDynamicOptions={setHasDynamicOptions}
                    />

                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <label>Comment *</label>
                            <input type="text" className="form-control input-default"
                                id="comment"
                                placeholder='Comment'
                                onChange={(e) => handleTextChange(e, e.target.type)}
                                value={attributeObj.comment}
                            />
                        </div>
                    </div>
                    <div className="form-group row mb-3">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="formAttribute"
                                        id="formAttribute"
                                        checked={attributeObj.formAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Form Attribute</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="defaultAttribute"
                                        id="defaultAttribute"
                                        checked={attributeObj.defaultAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Default Attribute</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="unique"
                                        id="unique"
                                        checked={attributeObj.unique}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Unique</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="nullValue"
                                        id="nullValue"
                                        checked={attributeObj.nullValue}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Null Value</label>
                                </div>
                                <div className="col-lg-4">
                                    <input
                                        type="checkbox"
                                        name="tableViewAttribute"
                                        id="tableViewAttribute"
                                        checked={attributeObj.tableViewAttribute}
                                        onChange={(e) => handleTextChange(e, e.target.type)}
                                    />
                                    <label className='ms-2'>Table View Attribute</label>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary"
                        onClick={handleCreateAttribute}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default TableAttributeAddEdit